import axios from "axios";
import { apiClient, API_BASE } from "./client";

// Public — the caller is not signed in yet, so this bypasses apiClient.
export async function partnerLogin({ email, password, techName }) {
  const res = await axios.post(`${API_BASE}/partner-auth/login`, {
    email,
    password,
    tech_name: techName,
  });
  return res.data.token;
}

// System admin only.
export async function createPartnerAccount(name) {
  const res = await apiClient("post", "/users/partners", { name });
  return res.data;
}

export async function fetchPartnerPasswordStatus(userId) {
  const res = await apiClient("get", `/users/${encodeURIComponent(userId)}/partner-password`);
  return res.data;
}

export async function setPartnerPassword(userId, password) {
  const res = await apiClient("put", `/users/${encodeURIComponent(userId)}/partner-password`, { password });
  return res.data;
}

export async function revealPartnerPassword(userId) {
  const res = await apiClient("get", `/users/${encodeURIComponent(userId)}/partner-password/reveal`);
  return res.data.password;
}
